/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import * as glassContext from 'ba-glass-context';
import { FeatureFlag } from '../constants/featureFlags';

let devModeForced = false;

export function forceDevMode(value) {
	devModeForced = value;
}

/**
 * Check if a feature is enabled.
 *
 * @param {FeatureFlag} feature - the feature to check;
 *
 * @return true if we're in dev mode and feature is defined or if feature is enabled with glass featureChecker service, false otherwise
 */
export function isFeatureEnabled(feature: FeatureFlag): boolean {
	const isEnabled = !!(feature && glassContext.isFeatureEnabled(feature.name));

	return !!(devModeForced || glassContext.isDevInstall()) || isEnabled;
}
